import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";

const name = "documents";
const pathData = "M504 8q8 8 8 17v460q0 10-7 18t-19 8H129q-12 0-19-8t-7-18V179q0-10 8-18L264 8q7-8 18-8h204q11 0 18 8zm-43 43H292l-10 10v67q0 21-15 36t-36 15h-67l-10 10v271h307V51zM205 281q0-11 7-18.5t19-7.5h153q11 0 18.5 7.5T410 281t-7.5 18-18.5 7H231q-26 0-26-25zm179 77q11 0 18.5 7.5T410 383t-7.5 18-18.5 8H231q-12 0-19-8t-7-18 7-17.5 19-7.5h153zM172 8q8 8 8 17.5T172 43L52 163v322q0 10-7 18t-19 8q-11 0-18-8t-7-18V153q0-11 8-18L136 8q8-8 18-8t18 8z";
const ltr = false;
const accData = null;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, collection, packageName });

export default "SAP-icons-v5/documents";
export { pathData, ltr, accData };